// Created/Updated by Developer - 05/01/2024

import { Component } from '@angular/core'
import { BaseController } from './base.controller';
import { Action, ApiResponseModel, CtCustomSelect, CtFormComponent, CtInputTextComponent, CtTableComponent, HttpService } from 'components';
import { Observable } from 'rxjs';

@Component({
	selector: 'in-vi01',
	template: `<div [id]="getId()" #target><div>`
})

export class InVi01 extends BaseController {



	constructor() {
		super();
		super.setViewCode('IN_VI01');
	}

	ngOnDestroy(): void {
	}


	/* ---------------------- CONTROLLER LOGIC ------------------- */
	private initValues(action: Action): void{
		let numPatrono: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
		let idAsociado: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);
		numPatrono.setValue(this.loggedUser.user.organization);
		idAsociado.setValue(this.loggedUser.user.id);

		this.setTableValues(action);
		this.setSummaryMonedero(action)

	}
	

	private setTableValues(action: Action): void {
		let numPatrono = this.utilService.getComponentRef(action.conditionParams[0]).getValue();
		let fec_inicio = this.utilService.getComponentRef(action.conditionParams[5]).getValue();
		let fec_final = this.utilService.getComponentRef(action.conditionParams[6]).getValue();
		let numReferencia = this.utilService.getComponentRef(action.conditionParams[7]).getValue();
		let contRequest = this.getTableMetadata(numPatrono,fec_inicio,fec_final,numReferencia);
		this.requestDataTableMovimientos(contRequest).subscribe({
            next: (response: ApiResponseModel) => {
              let data = response['Data']
              this.utilService.setAdnToAnyComponent(action.conditionParams[2], response['Data']);
            },
            error: (err: any) => {
              this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
                true, 'Aceptar', 'Cancelar');
            }
          });
	}

	public requestDataTableMovimientos (requestData): Observable<any> {
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/CUENTA_CLIENTE/SER_RET_MOVIMIENTOS_MONEDERO', requestData);
    }


	private setSummaryMonedero(action: Action) {
		let num_patrono = this.utilService.getComponentRef(action.conditionParams[0])
		let numPatrono = num_patrono.getValue();
		let contRequest = this.getListaMetadata(numPatrono);
		this.requestDataSummary(contRequest).subscribe({
			next: (response: ApiResponseModel) => {
				let data = response['Data']
				this.utilService.setAdnToAnyComponent(action.conditionParams[3] , response['Data']);
				let nomPatrono = this.utilService.getComponentRef(action.conditionParams[4]);
				nomPatrono.setValue(this.loggedUser.user.organization_name);
				num_patrono.setValue(this.loggedUser.user.organization);
			  },
			  error: (err: any) => {
				this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
				  true, 'Aceptar', 'Cancelar');
			  }
			});
	}
	private requestDataSummary(requestData ): Observable<any> {
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/CUENTA_CLIENTE/SER_RET_DATA_MONEDERO', requestData);
	}

	

	// Custom Select
	private setCustomSelects(action: Action): void {
		let selectDesde: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[0]);
		let selectHasta: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[1]);
		let numPatrono = this.loggedUser.user.organization;
		this.getListPeriodos(numPatrono).subscribe({
		  next: (response: ApiResponseModel) => {
			let adnList = response['Data'];
		 let optionsDesde = this.utilService.convertAdnToSelectOptions(adnList , selectDesde.getFieldValue(), selectDesde.getFieldText());
		 let optionsHasta = this.utilService.convertAdnToSelectOptions(adnList , selectHasta.getFieldValue(), selectHasta.getFieldText());
		 if (optionsDesde.length == 0){
		  optionsDesde = [{text: 'No hay periodos para filtrar', value: null }]
		  optionsHasta = [{text: 'No hay periodos para filtrar', value: null }]
		 }
		 selectDesde.options = optionsDesde;
		 selectHasta.options = optionsHasta;
		  }
	  });
	  }
	
	  private getListPeriodos(numPatrono): Observable<any> {
		const requestData: any = this.getListaMetadata(numPatrono);
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/CUENTA_CLIENTE/SER_RET_PERIODOS_MOVIMIENTOS', requestData);
	  }
	
	  private getListaMetadata(numPatrono){
	  let contRequest = {
		  "Type": 0,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [{
			  "Name": "NUM_CLIENTE",
			  "Alias": "NUM_CLIENTE",
			  "Value": numPatrono,
			  "Display": "",
			  "Type":1,
			  "FamilyId": ""
			}
			]
		  },
		  "Data": []
		}
		return contRequest;
	  }

	  private getTableMetadata(numPatrono,fec_inicio = null, fec_final = null, numReferencia = null){
		let contRequest = {
			"Type": 0,
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions":
			{
			  "Data": [{
				"Name": "NUM_CLIENTE",
				"Alias": "NUM_CLIENTE",
				"Value": numPatrono,
				"Display": "",
				"Type":1,
				"FamilyId": ""
			  },
			  {
				"Name": "FECHA_INI",
				"Alias": "FECHA_INI",
				"Value": fec_inicio,
				"Display": "",
				"Type":1,
				"FamilyId": ""
			  },
			  {
				"Name": "FECHA_FIN",
				"Alias": "FECHA_FIN",
				"Value": fec_final,
				"Display": "",
				"Type":1,
				"FamilyId": ""
			  },
			  {
				"Name": "NUM_REFERENCIA",
				"Alias": "NUM_REFERENCIA",
				"Value": numReferencia,
				"Display": "",
				"Type":1,
				"FamilyId": ""
			  }
			  ]
			},
			"Data": []
		  }
		  return contRequest;
		}


	/* -------------------- END CONTROLLER LOGIC ----------------- */

}